import { createFileRoute } from '@tanstack/react-router'
import { StaffBencana } from '../../../../components/StaffBencana'

export const Route = createFileRoute('/platform/desa/$desaId/bencana')({
  component: () => {
    const { desaId } = Route.useParams()
    return <StaffBencana desaId={desaId} />
  },
})
